import { Observable } from 'rxjs';
import { OrdersChart } from './orders-chart';
import { ProfitChart  } from './profit-chart';

export interface DashboardChartSummary {
  title: string;
  value: number | string;
}

export abstract class DashboardChartData {
  abstract getDashboardChartSummary(): Observable<DashboardChartSummary[]>;
  abstract getOrdersChartData(period: string): Observable<OrdersChart>;
  abstract getProfitChartData(period: string): Observable<ProfitChart>;
}
